import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { RefBadge } from "../../components/neu/RefBadge";
import { hrRequests, approveResumeLeave } from "../../api/hr";

// موافقات المدير على طلبات استئناف/إلغاء الإجازة (الحالة: طلب إلغاء).
export const LeaveResumeApprovals = () => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    hrRequests("cancel_requested").then((d) => setItems(d.leaves || [])).catch(() => setItems([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const decide = async (id, approve) => {
    try {
      await approveResumeLeave(id, approve, null);
      toast.success(t(`approvals.${approve ? "approve" : "reject"}d`));
      load();
    } catch {
      toast.error(t("errors.generic"));
    }
  };

  if (!items.length) return null;
  return (
    <div className="grid gap-4" data-testid="leave-resume-approvals">
      <p className="label-xs">{t("myRequests.resumeApprovalsTitle", { count: items.length })}</p>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {items.map((it) => (
          <NeuCard key={it.id} className="animate-rise-in p-5" data-testid={`leave-resume-approval-${it.id}`}>
            <span className="inline-block rounded-full bg-rose-500 px-2.5 py-0.5 text-xs font-black text-white">
              {t("myRequests.resumeBadge")}
            </span>
            <p className="mt-2 text-sm font-black">{it.user_name || it.user_id}</p>
            <RefBadge value={it.ref_no} className="mt-1" />
            <p className="mt-2 font-mono text-xs text-muted-foreground">{it.start_date} → {it.end_date}</p>
            <div className="mt-4 flex gap-2">
              <NeuButton variant="primary" className="flex items-center gap-2" data-testid={`leave-resume-approve-${it.id}`} onClick={() => decide(it.id, true)}>
                <Check className="h-4 w-4" /> {t("approvals.approve")}
              </NeuButton>
              <NeuButton variant="danger" className="flex items-center gap-2" data-testid={`leave-resume-reject-${it.id}`} onClick={() => decide(it.id, false)}>
                <X className="h-4 w-4" /> {t("approvals.reject")}
              </NeuButton>
            </div>
          </NeuCard>
        ))}
      </div>
    </div>
  );
};
